import gsap from 'gsap'
import store from '../store'

import SplitText from '../vendor/gsap/SplitText'

gsap.registerPlugin(SplitText)

export default class Intro {
  createTimeline() {
    const tl = gsap.timeline({
      defaults: {
        duration: 1.5,
        ease: 'power3.inOut',
      },
    })

    let title = '#zero-fee h1'
    let headCaption = '#zero-fee h3'
    let caption = '#zero-fee h2'

    tl.to('main', {
      opacity: 1
    })

    // tl
    //   .from(title, {
    //     opacity: 0,
    //   }, 0)
    //   .from(headCaption, {
    //     opacity: 0,
    //   }, 0)
    //   .from(caption, {
    //     opacity: 0,
    //   }, 0)    
    //   .to('header', {
    //     opacity: 1,
    //   }, 0)    
    //   .to('.mouse', {
    //     opacity: 1,
    //   }, 0)      
  }
}